import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import CartCheckoutFooter from '../CartCheckoutFooter';
import TaxDetails from './TaxDetails';
import TnC from './TnC';
var GridFooter = function GridFooter(_ref) {
  var isMobile = _ref.isMobile,
    reviewStepEnabled = _ref.reviewStepEnabled,
    isReviewStep = _ref.isReviewStep,
    ctaContent = _ref.ctaContent,
    newUserNoMop = _ref.newUserNoMop,
    selectedPrice = _ref.selectedPrice,
    tax = _ref.tax,
    termsAndConditions = _ref.termsAndConditions,
    tncProps = _ref.tncProps,
    basePrice = _ref.basePrice,
    isDiscounted = _ref.isDiscounted;
  return /*#__PURE__*/React.createElement(CartCheckoutFooter, {
    isMobile: isMobile,
    isReviewStep: isReviewStep,
    ctaContent: ctaContent,
    reviewStepEnabled: reviewStepEnabled,
    newUserNoMop: newUserNoMop,
    taxDetailsContent: /*#__PURE__*/React.createElement(TaxDetails, {
      isReviewStep: isReviewStep,
      price: selectedPrice,
      basePrice: basePrice,
      isDiscounted: isDiscounted,
      reviewStepEnabled: reviewStepEnabled,
      tax: tax
    }),
    tncContent: termsAndConditions ? /*#__PURE__*/React.createElement(TnC, _extends({}, tncProps, {
      termsAndConditions: termsAndConditions
    })) : undefined
  });
};
export default GridFooter;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/views/CartCheckout/internals/GridFooter.js
// module id = 1468
// module chunks = 11